<template>
    <v-dialog v-model="dialogOpen" persistent :max-width="maxWidth" height="500px">
        <v-card>
            <toolbar-page :title="title" disable-icon>
                <template slot="buttons">

                    <v-tooltip top color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" @click="dialogOpen=false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close</span>
                    </v-tooltip>
                </template>

            </toolbar-page>

            <v-card-text>

                <v-container fluid class="pa-0">
                    <v-row no-gutters>

                        <v-col cols="12">
                            <v-alert type="info" v-model="showUploadInfo" class="body-2 mt-2 mb-2">
                               {{description}}
                            </v-alert>

                            <v-alert type="info" v-model="showResizeInfo" class="body-2 mb-2">
                                Please resize using the slider control at the bottom or use buttons to flip and transform the image till you are satisfied.
                            </v-alert>
                        </v-col>

                        <v-col cols="12" class="mt-0 mb-0">
                            <v-image-input
                                    v-model="imageData"
                                    :image-quality="1"
                                    :clearable="true"
                                    image-format="png,jpeg"
                                    :image-width="width"
                                    :image-height="height"
                                    image-min-scaling="cover"
                                    :image-max-scaling="2"
                                    upload-icon="mdi-cloud-upload"
                                    rotate-clockwise-icon="mdi-rotate-right-variant"
                                    rotate-counter-clockwise-icon="mdi-rotate-left-variant"
                                    flip-vertically-icon="mdi-flip-vertical"
                                    flip-horizontally-icon="mdi-flip-horizontal"
                                    clear-icon="mdi-delete">
                            </v-image-input>
                        </v-col>

                        <v-col cols="12" class="mt-0">
                            <v-btn :disabled="!imageData" color="primary" @click="accepted">I am happy let's go
                            </v-btn>
                            <v-btn color="secondary" @click="dialogOpen=false">Cancel</v-btn>
                        </v-col>

                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

    </v-dialog>
</template>

<script>

    import ToolbarPage from './ToolbarPage';
    import VImageInput from 'vuetify-image-input/a-la-carte';

    export default {

        components: {
            ToolbarPage,
            VImageInput
        },

        props: {
            value: {
                type: Boolean,
                default: false,
                required: false
            },
            title: {
                type: String,
                required: true,
            },
            description: {
                type: String,
                required: true,
            },
            width: {
                type: Number,
                required: true,
            },
            height: {
                type: Number,
                required: true
            },
            maxWidth: {
                type: Number,
                required: false,
                default: 1100,
            }
        },

        data() {
            return {
                imageData: ''
            }
        },
        computed: {
            showUploadInfo() {
                return !this.imageData;
            },
            showResizeInfo() {
                return !!this.imageData;
            },
            dialogOpen: {
                get() {
                    return this.value;
                },
                set() {
                    this.closeDialog();
                }
            }
        },

        methods: {
            accepted() {

                this.$emit('change', {
                    imageData: this.imageData,
                    blob: this.dataURItoBlob(this.imageData)
                });
            },

            dataURItoBlob(dataURI) {
                // convert base64 to raw binary data held in a string
                // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
                let byteString = atob(dataURI.split(',')[1]);

                // separate out the mime component
                let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

                // write the bytes of the string to an ArrayBuffer
                let ab = new ArrayBuffer(byteString.length);

                // create a view into the buffer
                let ia = new Uint8Array(ab);

                // set the bytes of the buffer to the correct values
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }

                // write the ArrayBuffer to a blob, and you're done
                return new Blob([ab], {type: mimeString});
            },

            closeDialog() {
                this.$emit('input', false);
            },
        }
    }
</script>
